import React from "react";
import { TableWidget } from "../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getDeliveryArrangement } from "../../../redux/api/picking.api";

import {
  deliveryArrangementTableHeader,
  getDeliveryArrangementTableData,
} from "./components/tableConfigs/deliveryArrangementTableConfig";
import DeliveryArrangementActionButton from "./components/TableActionsButtonsComponents/DeliveryArrangementActionButton";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

function DeliveryArrangement() {
  const dispatch = useAppDispatch();
  const {
    picking: {
      deliveryArrangement: {
        data: { nrTotal, orderPicking },
        isLoadingDeliveryArrangement,
      },
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableFilter
    ) {
      dispatch(
        getDeliveryArrangement({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          status: action.tableFilter?.status ?? 0,
          facturi: action.tableSearch?.facturi ?? "",
          ruta: action.tableSearch?.ruta ?? "",
          deliveryPoint: action.tableSearch?.deliveryPoint ?? "",
          commandNumber: action.tableSearch?.commandNumber ?? "",
        }),
      );
    }
  };

  return (
    <TableWidget
      tableTitle={"Dispozitii de livrare"}
      tableHeaderData={deliveryArrangementTableHeader}
      tableItemsData={getDeliveryArrangementTableData(orderPicking)}
      totalItems={nrTotal}
      borderedRow
      tableLoading={isLoadingDeliveryArrangement}
      ActionButtonsComponent={(props: any) => (
        <DeliveryArrangementActionButton {...props} />
      )}
      handleTableActions={handleTableActions}
    />
  );
}

export default DeliveryArrangement;
